import { useContext } from 'react'
import { GlobalContext } from 'App'
import { motion } from 'framer-motion';
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'constants/animation-properties';

import Img1 from 'assets/Home/portfolio/sangin1.avif'
import Img2 from 'assets/Home/portfolio/sangin2.avif'

const Sangin = ({ data }: any) => {
    const { isTablet } = useContext(GlobalContext)

    return (
        <>
            <section className='pb-24 container'>
                <motion.h3
                    className='mb-2 text-[#B8B8B8] text-40 tablet:text-2xl'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    Main Page
                </motion.h3>

                <motion.h4
                    className='mb-6 font-semibold text-32 text-black tablet:text-xl'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    전통시장 상인들에게 실질적으로 유용한 정책{!isTablet && <br />}
                    및 주요이슈 등 맞춤형 정보를 제공하는 {!isTablet && <br />}
                    카카오채널 기반 정보교류 플랫폼
                </motion.h4>

                <motion.h4
                    className='mb-6 text-[#656565] tablet:text-lg text-2xl'
                    transition={{ delay: 0.4 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    전통시장 지원사업 안내 및 혜택, 국가안전대진단, 물가안전용{!isTablet && <br />}
                    수산물 공급, 화재예방, 감염병 예방 등 다양한 정보를{!isTablet && <br />}
                    전통시장 상인들에게 전달하는 소통창구입니다.
                </motion.h4>

                <motion.img
                    src={Img1}
                    alt="Img1"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                </motion.img>
            </section>

            <section className='pb-24 container'>
                <motion.img
                    src={Img2}
                    alt="Img2"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                </motion.img>
            </section>
        </>
    )
}

export default Sangin
